/**
 * Warehouse-type logo for the Audiences list identity cell (ACT2-640). Shared by the table row and
 * the card so the two views cannot drift on size or hover text.
 *
 * Phrasing-only (`<span>`s): the table cell sits inside the row-activator `<button>`, which forbids
 * flow content and a second focusable. No Radix tooltip — `title` recovers the warehouse name on
 * hover without planting a second tab stop. The mark is decorative. The row/card accessible name
 * carries the warehouse via {@link audienceRowLabel}.
 */
import type { ReactElement } from 'react';

import { warehouseTypeMeta } from '@/settings/components/warehouseAccount/warehouseTypes';

import { audienceWarehouseDisplayName } from '../lib/audienceList';

interface AudienceWarehouseMarkProps {
  /** Backend warehouse `type` (e.g. `POSTGRES`). Empty → generic icon. */
  type: string;
  /** Warehouse account name — hover `title`. Empty → type label. */
  warehouseName: string;
}

export function AudienceWarehouseMark({ type, warehouseName }: AudienceWarehouseMarkProps): ReactElement {
  const { Icon } = warehouseTypeMeta(type);
  return (
    <span title={audienceWarehouseDisplayName(warehouseName, type)} aria-hidden className="inline-flex shrink-0">
      <Icon className="size-4" />
    </span>
  );
}
